import * as types from './LoginActionType';

export const loginRequest = data => ({
    type: types.LOGIN_REQUEST,
    payload: data,
});
export const loginSuccess = data => ({
    type: types.LOGIN_SUCCESS,
    payload: data,
});
export const loginFailure = data => ({
    type: types.LOGIN_FAILURE,
    payload: data,
});

// Informational status returned with a success response (e.g. StatusId=4 with Success=true)
export const loginInfo = data => ({
    type: types.LOGIN_INFO,
    payload: data,
});

export const logoutRequest = data => ({
    type: types.LOGOUT_REQUEST,
    payload: data,
});
export const logoutSuccess = data => ({
    type: types.LOGOUT_SUCCESS,
    payload: data,
});
export const logoutFailure = data => ({
    type: types.LOGOUT_FAILURE,
    payload: data,
});

export const noAccess = (data) => ({
    type: types.NO_ACCESS,
    payload: data,
});

export const resetNoAccess = () => ({
    type: types.RESET_NO_ACCESS
});

// MFA (Authenticator TOTP)
export const mfaRequired = (data) => ({
    type: types.MFA_REQUIRED,
    payload: data,
});
export const mfaSetupRequired = (data) => ({
    type: types.MFA_SETUP_REQUIRED,
    payload: data,
});
export const verifyMfaRequest = (data) => ({
    type: types.VERIFY_MFA_REQUEST,
    payload: data,
});
export const verifyMfaSuccess = (data) => ({
    type: types.VERIFY_MFA_SUCCESS,
    payload: data,
});
export const verifyMfaFailure = (data) => ({
    type: types.VERIFY_MFA_FAILURE,
    payload: data,
});
export const resetMfaState = () => ({
    type: types.RESET_MFA_STATE,
});